import PropTypes from 'prop-types'
import moment from 'moment'
import { useTranslation } from 'react-i18next'

import { displayWithCurrency } from '../../../../../utility/currency'
import AvatarStack from '../../../../common/avatar/AvatarStack'

import classes from './FamilyLeaderboardRow.module.scss'
import classnames from 'classnames'

const FamilyLeaderboardRow = ({ rank, family, currency }) => {
  const { t } = useTranslation()

  const formatTenure = (joinedAt) => {
    if (!joinedAt) {
      return null
    }

    const months = moment().diff(moment(joinedAt), 'months')

    if (months < 1) {
      return t('dashboard.business.lifetimeValueLeaderboard.familyLeaderboardRow.tenureLessThanMonth')
    }
    if (months < 12) {
      return t('dashboard.business.lifetimeValueLeaderboard.familyLeaderboardRow.tenureMonths', { count: months })
    }

    const years = Math.floor(months / 12)
    return t('dashboard.business.lifetimeValueLeaderboard.familyLeaderboardRow.tenureYears', { count: years })
  }

  const tenure = formatTenure(family.joinedAt)

  return (
    <div className={classnames('mt-3 mx-3 d-flex align-items-center', classes.leaderboardRow)}>
      <div className={classes.rank}>
        {t('dashboard.business.lifetimeValueLeaderboard.familyLeaderboardRow.rankBadge', { rank })}
      </div>
      <div className={classnames('d-flex flex-column', classes.familyInfo)}>
        <span className={classes.name}>{family.name}</span>
        <span className={classes.subline}>
          {t('dashboard.business.lifetimeValueLeaderboard.familyLeaderboardRow.enrollmentsCount', { count: family.enrollmentsCount })}
          {tenure ? ` · ${tenure}` : ''}
        </span>
      </div>
      <AvatarStack users={family.students} interactive={false} className={classes.avatarStack} />
      <div className={classnames('d-flex flex-column align-items-end', classes.revenue)}>
        <span>{displayWithCurrency(family.totalRevenue, currency, true)}</span>
        <span>{t('members.columns.totalRevenue')}</span>
      </div>
    </div>
  )
}

FamilyLeaderboardRow.propTypes = {
  rank: PropTypes.number.isRequired,
  family: PropTypes.shape({
    name: PropTypes.string,
    enrollmentsCount: PropTypes.number,
    joinedAt: PropTypes.string,
    totalRevenue: PropTypes.number,
    students: PropTypes.array,
  }).isRequired,
  currency: PropTypes.object,
}

export default FamilyLeaderboardRow
